export const HELP_URL = "https://starbrix.app/core/help"
export const CONTACT_SUPPORT_URL = "https://www.starbrix.app/contact-support"
export const TERMS_OF_SERVICE_URL = "https://www.starbrix.app/core/legal#terms-of-service"
export const PRIVACY_POLICY_URL = "https://www.starbrix.app/core/legal#privacy-policy"
